import { render, staticRenderFns } from "./customGroupModal.vue?vue&type=template&id=72cdbe78&scoped=true&"
import script from "./customGroupModal.vue?vue&type=script&lang=js&"
export * from "./customGroupModal.vue?vue&type=script&lang=js&"
import style0 from "./customGroupModal.vue?vue&type=style&index=0&id=72cdbe78&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72cdbe78",
  null
  
)

export default component.exports